var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 60 Q30 50 40 40 Q50 25 60 40 L60 65 Q55 70 35 65 Z",
    fill: "#B71C1C",
    stroke: "#8B0000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35 Q66 30 80 32 Q84 33 82 38 Q77 39 66 39 Q63 37 60 35 Z",
    fill: "#C0C0C0",
    stroke: "#A0A0A0",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 35,
    width: 2,
    height: 6,
    fill: "#A0A0A0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 34,
    width: 2,
    height: 6,
    fill: "#A0A0A0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 33,
    width: 2,
    height: 6,
    fill: "#A0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60 L45 85 L60 85 L58 60 Z",
    fill: "#2E2E2E",
    stroke: "#1A1A1A",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65 L52 80 L54 80 L53 65 Z",
    fill: "#1A1A1A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 45,
    r: 3,
    fill: "#8E0000",
    stroke: "#5E0000",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35 Q67 33 76 34 Q79 35 78 37 Q75 37 68 37 Q66 36 64 35 Z",
    fill: "#E0E0E0",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33 Q70 31 74 32 Q76 32 75 34 Q73 34 71 34 Q69 33 69 33 Z",
    fill: "#E0E0E0",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 85 Q35 92 20 88",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38 62 Q34 52 44 42 Q47 35 55 42 L55 65 Q50 67 38 62 Z",
    fill: "#D32F2F",
    opacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34 58 Q30 48 40 38 Q46 30 52 38 L52 63 Q48 68 34 58 Z",
    fill: "#A10F0F",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTankIcon);
export default __webpack_public_path__ + "static/media/TankIcon.080865777488247c746c3e8a20210f46.svg";
export { ForwardRef as ReactComponent };